module.exports = __webpack_public_path__ + "img/mcqoptiondelete.f772e95e.svg";